
import Vue from 'vue';
import Vuex from 'vuex';
import modules from './modules';

Vue.use(Vuex);

const store = new Vuex.Store({
  state: {
    newOrders: [],
    permissions: [],
    isShowModal: true
  },
  mutations: {
    addNewOrder(state, newOrder) {
      state.newOrders.push(newOrder);
    },
    setPermissions(state, permissions) {
      state.permissions = permissions;
    },
    setIsShowModal(state, isShowModal) {
      state.isShowModal = isShowModal
    }
  },
  getters: {
    isShowModal: state => state.isShowModal,
    newOrders: state => state.newOrders,
    permissions: state => state.permissions,
    setIsShowModal: state => state.setIsShowModal
  },
  modules,
  // Enable strict mode in development to get a warning
  // when mutating state outside of a mutation.
  // https://vuex.vuejs.org/guide/strict.html
  strict: process.env.NODE_ENV !== 'production',
});


export default store;


